import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import log from 'client/lib/log';

import { SR_API_ACTION_PARTNER_LISTINGS_CSV_IMPORT } from 'api/actionTypes';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import withApiState from 'client/helpers/withApiState';
import postWithState from 'client/actions/postWithState';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

const formFields = [
  {
    id: 'csvFileUrl',
    title: 'CSV',
    type: 'file_single',
    validations: ['required'],
    properties: {
      fileAccept: '.csv',
      filePath: '/partner-listings-import-csv-data/{uuid}',
    },
  },
];

@withApiState({
  partnerListingsCsvImportApiState: {
    action: SR_API_ACTION_PARTNER_LISTINGS_CSV_IMPORT,
  },
})
class SrPartnerCsvListingsUploader extends Component {
  static propTypes = {
    apartmentId: PropTypes.number.isRequired,
    partnerListingsCsvImportApiState: PropTypes.object.isRequired,
    onSubmit: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
  };

  _onSubmit = ({ csvFileUrl }) => {
    const { apartmentId, onSubmit, dispatch } = this.props;

    if (!global.confirm('Are you sure you want to upload the listings CSV file?')) {
      return;
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_PARTNER_LISTINGS_CSV_IMPORT,
      payload: {
        apartmentId,
        csvFileUrl,
      },
      onSuccess() {
        global.alert('Done.');
        if (onSubmit) {
          onSubmit(csvFileUrl);
        }
      },
      onError(error) {
        log.error(error);
        global.alert(`ERROR: ${error.message}`);
      },
    });
  };

  render() {
    const { partnerListingsCsvImportApiState } = this.props;

    return (
      <Formik
        initialValues={createInitialValues({ formFields })}
        validate={createFormValidationFn(formFields)}
        onSubmit={this._onSubmit}
        render={(formikBag) => (
          <Form>
            {formFields.map((formField) => (
              <SrFormikField key={formField.id} formField={formField} formikBag={formikBag} />
            ))}
            <ButtonDeprecated
              type="submit"
              disabled={partnerListingsCsvImportApiState.inProgress || !formikBag.isValid}
            >
              {partnerListingsCsvImportApiState.inProgress ? 'please wait...' : 'submit'}
            </ButtonDeprecated>
          </Form>
        )}
      />
    );
  }
}

SrPartnerCsvListingsUploader.displayName = 'SrPartnerCsvListingsUploader';

export default SrPartnerCsvListingsUploader;
